module.exports = __webpack_public_path__ + "img/ic_sort.44f7fc21.svg";